// to top right away
if (window.location.hash) scroll(0, 0);

document.addEventListener('DOMContentLoaded', function () {
  // Animations on scroll
  new WOW().init();

  // Parallax
  var lastScrollTop = 0;
  window.addEventListener('scroll', function () {
    var st = window.scrollY;
    lastScrollTop = st;

    var parallaxElements = document.querySelectorAll('.js-parallax');
    if (parallaxElements.length) {
      parallaxElements.forEach(function (el) {
        var start = el.getBoundingClientRect().top + window.scrollY;
        var speedRatio = (window.innerWidth >= 768) ? el.dataset.speedratio : el.dataset.speedratio * 3;
        var height = window.innerHeight - document.querySelector('.socket').offsetHeight;
        var movement = st;
        var heihgtBG = (window.innerWidth >= 768) ? (2242 * window.innerWidth) / 1296 : (2286 * window.innerWidth) / 710;
        var gap = 0;
        var max_top = heihgtBG - height;

        if ((movement / speedRatio) < max_top) {
          el.style.backgroundPosition = '50% ' + -((movement / speedRatio) - gap) + 'px';
        }
      });
    }
  });

  var lastScrollPosition = 0;
  window.onscroll = function () {
    var newScrollPosition = window.scrollY;
    if (newScrollPosition < lastScrollPosition) {
      document.body.classList.remove('std');
      document.body.classList.add('stu');
    } else {
      document.body.classList.remove('stu');
      document.body.classList.add('std');
    }
    lastScrollPosition = newScrollPosition;
  };

  // Owl Carousel
  if (typeof jQuery !== 'undefined' && typeof jQuery.fn.owlCarousel !== 'undefined') {
    jQuery('.js-carousel').owlCarousel({
      items: 1,
      loop: true,
      autoplay: true,
      autoplayHoverPause: true
    });
  }

  // El rollo de las calles vacías
  var listMenu = document.querySelector('.js-listmenu');
  if (listMenu){
    for (let i = document.querySelectorAll('.stage').length + 1; i <= 14; i++) {
      let calle = (i < 13) ? "ST" : "ST";
      let item = document.createElement('li');
      item.className = 'stage-empty wow bounceIn';
      item.innerHTML = `<button class="btn-stage"><span>${i}TH <sup>${calle}</sup></span><span>Próximamente</span></button>`;
      listMenu.appendChild(item);
    }
  }

  // Añadir un botón para volver arriba
  var lastItem = document.createElement('li');
  lastItem.className = 'stage-empty wow bounceIn last-stage';
  lastItem.innerHTML = '<a href="#transition" class="btn-stage js-smoothScroll">SUBIR</a>';
  listMenu.appendChild(lastItem);

  // Eventos delegados en acciones
  document.body.addEventListener('click', function (e) {
    var target = e.target.closest('.js-smoothScroll');
    if (target) {
      e.preventDefault();
      var scrollTarget = document.querySelector(target.getAttribute('href'));
      if (scrollTarget) {
        window.scrollTo({
          top: scrollTarget.offsetTop,
          behavior: 'smooth'
        });
      }
      return;
    }

    target = e.target.closest('.js-getlink');
    if (target) {
      var link = target.querySelector('a');
      if (link) {
        location.href = link.getAttribute('href');
        dataLayer.setPixel('facebook', 'view_content_micro_hijas_capitan');
      }
      e.stopPropagation();
      return;
    }
    target = e.target.closest('.js-asyncmodal');
    if (target) {
      e.preventDefault();
      var url = target.getAttribute('href');
      var modalTarget = document.querySelector(target.dataset.target);

      fetch(url + '?async=true')
        .then(response => response.text())
        .then(result => {
          // Assuming Bootstrap modal
          var modal = new bootstrap.Modal(modalTarget);
          modal.show();
          modalTarget.querySelector('.modal-legal').innerHTML = result;

          var cookiesSetUp = document.querySelectorAll('.js-opencookies');
          cookiesSetUp.forEach(function (element) {
            element.addEventListener('click', function () {
              document.getElementsByClassName('ot-floating-button__open')[0].click();
            });
          });
        })
        .catch(() => {
          var errorDiv = document.createElement('div');
          errorDiv.className = 'ajax-error text-center';
          errorDiv.textContent = 'Error';
          modalTarget.appendChild(errorDiv);
        });
    }
  });
});

window.addEventListener('load', function () {
  var stages = document.querySelector('.js-stages');
  if(stages){
    var heightStages = stages.offsetHeight;
    stages.style.height = (heightStages - 18) + 'px';
  }
  var loader = document.querySelector('.loader');
  //console.log('cargado');
  if (loader) {
    loader.style.transition = 'opacity 0.55s';
    loader.style.opacity = 0;
    setTimeout(function () {
      loader.style.display = 'none';
      if (window.location.hash) {
        var anchor = document.querySelector(window.location.hash);
        if (anchor) {
          window.scrollTo({
            top: anchor.offsetTop,
            behavior: 'smooth'
          });
        }
      }
    }, 550);
  }
});

setTimeout(function () { scroll(0, 0); }, 1);
